export const styles = theme => ({
    inputField: {
        margin: "0.5rem 0",
    },
    adornmentIcon: {
        margin: "4px"
    }
});
